import { Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocaleDataService } from '../angular-common/locale-data.service';

@Injectable()
export class NotificationDataService {

    constructor(private _injector: Injector) {
    }

    //TODO: parametrizzare se uscire susnackbar o growl
    public openSnackBar(message: string, action?: string) {
        this._injector.get(MatSnackBar).open(message, action, { horizontalPosition: 'center', direction: this._injector.get(LocaleDataService).direction, duration: 7000 })
    };

}